import { jsx as _jsx } from "react/jsx-runtime";
import StatTile from '../common/StatTile';
function getAvailabilityColor(blocks) {
    if (blocks <= 2)
        return 'error.main';
    if (blocks <= 4)
        return 'warning.main';
    return 'success.main';
}
export default function AvailableTile({ availableBlocks }) {
    return (_jsx(StatTile, { label: "Available", value: availableBlocks, valueVariant: "h3", valueColor: getAvailabilityColor(availableBlocks), caption: "blocks" }));
}
